import React from 'react';

const PageArrowPrev = () => (
  <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="#DDDDDD" fillRule="evenodd" clipRule="evenodd" d="M5.74663 8.05811C5.74867 7.81075 5.65492 7.57184 5.4843 7.38958L2.69572 4.50073L5.4843 1.61189C5.83857 1.23507 5.83857 0.654852 5.4843 0.278032C5.31908 0.101338 5.08578 0.000732422 4.84126 0.000732422C4.59673 0.000732422 4.36343 0.101338 4.19822 0.278032L0.766932 3.83413C0.411022 4.20957 0.411022 4.79061 0.766932 5.16605L4.19494 8.72343C4.36016 8.90013 4.59345 9.00073 4.83798 9.00073C5.0825 9.00073 5.3158 8.90013 5.48102 8.72343C5.65144 8.54233 5.74522 8.30448 5.74335 8.05811" />
  </svg>
);

export default PageArrowPrev;